import { NavItem } from '@billy/design-system'
import { useMemo } from 'react'

import { useSendAsEmailModal } from '../contexts/sendAsEmailModalContext'

export const useContactPersonItems = () => {
  const { invoiceContactPersons, isLoading } = useSendAsEmailModal()

  const contactPersonItems: NavItem[] = useMemo(() => {
    const contactPersonsWithEmail = invoiceContactPersons.filter((contactPerson) => !!contactPerson.email)

    return contactPersonsWithEmail.map((contactPerson) => ({
      id: contactPerson?.id || '',
      children: contactPerson.name,
      value: contactPerson.email || '',
    }))
  }, [invoiceContactPersons])

  return { contactPersonItems, isLoading }
}
